import heroImage from './HeroImage';
import infographic from './Infographic';
import longformGallery from './LongformGallery';
import longformRow from './LongformRow';
import parallaxImageTextRight from './ParallaxImageTextRight';
import thumbnailCarousel from './ThumbnailCarousel';
import slideSummary from './SlideSummary';
import floatingSideButton from './FloatingSideButton';
import liveBlogList from './LiveBlogList';
export default {
  heroImage,
  infographic,
  longformGallery,
  longformRow,
  parallaxImageTextRight,
  thumbnailCarousel,
  slideSummary,
  floatingSideButton,
  liveBlogList
};
//# sourceMappingURL=index.js.map